import React from 'react';
import { UserCog, X } from 'lucide-react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { useTranslation } from '../hooks/useTranslation';
import { useDevConsoleStore } from '../stores/useDevConsoleStore';

/**
 * Role Simulation Indicator
 * Shows a badge in the header when role simulation is active
 */
export const RoleSimulationIndicator: React.FC = () => {
  const { translate } = useTranslation();
  const { simulatedRoles, isRoleSimulationEnabled, setRoleSimulationEnabled, setSimulatedRoles } =
    useDevConsoleStore();

  if (!isRoleSimulationEnabled || !simulatedRoles || simulatedRoles.length === 0) {
    return null;
  }

  const handleDisable = () => {
    // Disable role simulation in store
    setRoleSimulationEnabled(false);
    // Clear simulated roles in store
    setSimulatedRoles([]);
    // Clear localStorage to prevent restoration on navigation
    localStorage.setItem('dev-console-role-simulation-enabled', 'false');
    localStorage.removeItem('dev-console-simulated-roles');
  };

  return (
    <Badge
      variant="outline"
      className="bg-yellow-500/10 text-yellow-700 dark:text-yellow-400 border-yellow-500/50 hover:bg-yellow-500/20 flex items-center gap-1.5 px-2 py-1"
      title={`Role simulation active: ${simulatedRoles.join(', ')}`}
    >
      <UserCog className="h-3 w-3" />
      <span className="text-xs font-medium">
        {simulatedRoles.join(', ')}
      </span>
      <Button
        variant="ghost"
        size="icon"
        className="h-4 w-4 p-0 hover:bg-yellow-500/20"
        onClick={handleDisable}
        title="Disable role simulation"
      >
        <X className="h-3 w-3" />
      </Button>
    </Badge>
  );
};

